import { Text } from '@weareconceptstudio/core';

//* Styles
import TabStyle from './style';

const Tab = ({ text, onClick = null, className = '', active }) => {
	return (
		<TabStyle
			onClick={onClick}
			className={`tab-wrapper ${className} ${active ? 'active' : ''}`}
		>
			<Text
				className={`p5 green-1000 font-larken-regular tab-text`}
				text={text}
			/>
		</TabStyle>
	);
};

export default Tab;
